import { settleApiCall } from '../api/utils';
import { convertItemDTOToPopulatedItem, convertPopulatedItemToItemDTO } from '../utils/converters';
import { attachCreatedEntitiesToItem } from '../utils/item';
import { createOrUpdateModifierGroups } from './createOrUpdateModifierGroups';
import { createPriceVariants } from './createPriceVariants';
export const createOrUpdateItem = async _ref => {
  var _createOrUpdateModifi, _createPriceVariantsR, _createOrUpdateModifi2, _createPriceVariantsR2, _itemWithCreatedEntit;
  let {
    item,
    itemsClient,
    modifierGroupsClient,
    modifiersClient,
    priceVariantsClient,
    isPriceVariantsToggled,
    itemModifierGroupsToCreate,
    itemPriceVariantsToCreate,
    populationLevel,
    source
  } = _ref;
  let createOrUpdateModifierGroupsResponse;
  let createPriceVariantsResponse;
  const itemLabels = item.labels;
  if (itemModifierGroupsToCreate) {
    createOrUpdateModifierGroupsResponse = await createOrUpdateModifierGroups({
      modifierGroups: itemModifierGroupsToCreate,
      modifierGroupsClient,
      modifiersClient
    });
  }
  if ((_createOrUpdateModifi = createOrUpdateModifierGroupsResponse) != null && _createOrUpdateModifi.hasError) {
    return createOrUpdateModifierGroupsResponse;
  }
  if (isPriceVariantsToggled && itemPriceVariantsToCreate) {
    createPriceVariantsResponse = await createPriceVariants(itemPriceVariantsToCreate || [], priceVariantsClient);
  }
  if ((_createPriceVariantsR = createPriceVariantsResponse) != null && _createPriceVariantsR.hasError) {
    return createPriceVariantsResponse;
  }
  const itemWithCreatedEntities = attachCreatedEntitiesToItem({
    item,
    createdModifierGroups: (_createOrUpdateModifi2 = createOrUpdateModifierGroupsResponse) == null ? void 0 : _createOrUpdateModifi2.data,
    createdPriceVariants: (_createPriceVariantsR2 = createPriceVariantsResponse) == null ? void 0 : _createPriceVariantsR2.data
  });
  const itemInDTOForm = convertPopulatedItemToItemDTO(itemWithCreatedEntities, isPriceVariantsToggled, populationLevel);
  const createOrUpdateItemResponse = await settleApiCall(() => item.id ? itemsClient.update(itemInDTOForm) : itemsClient.create(itemInDTOForm, source));
  if (createOrUpdateItemResponse.hasError) {
    return createOrUpdateItemResponse;
  }
  const populatedItem = convertItemDTOToPopulatedItem(createOrUpdateItemResponse.data, itemWithCreatedEntities.modifierGroups, (_itemWithCreatedEntit = itemWithCreatedEntities.priceVariants) == null ? void 0 : _itemWithCreatedEntit.variants, itemLabels, populationLevel);
  return {
    data: populatedItem,
    hasError: false
  };
};
//# sourceMappingURL=createOrUpdateItem.js.map